// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3X-H-","sendOtp":"AuthorizeToLogin_sendOtp__2aDnW"};